import { createRouter, createWebHistory } from "vue-router";
const router = createRouter({ 
    history: createWebHistory(""), 
    routes: [
        { 
            path: "/:lang?",
            name: "main",
            component: () => import("../components/Main.vue"),
            meta: {
                defaultLanguage: "ko",
            },
        }, 
    ], 
}); 
export default router;